import { components } from "@certn/legacy-api/generated-schemas/people";
import i18next, { t } from "i18next";
import { object, string } from "yup";

import { BirthplaceInputField } from "./BirthplaceInputField";
import { BirthplaceSummaryField } from "./BirthplaceSummaryField";
import { FieldType } from "../types";

export function BirthplaceField(
  field: components["schemas"]["BirthPlaceCheckField"]
): FieldType<components["schemas"]["BirthPlaceCheckField"]> {
  return {
    field,
    inputElement: <BirthplaceInputField key={field.name} field={field} />,
    summaryElement: () => (
      <BirthplaceSummaryField key={field.name} field={field} />
    ),
    schema: birthplaceSchema,
    initialValue: field.value || {
      birth_country: i18next.language.split("-")[1],
      birth_province_state: "",
      birth_city: "",
    },
  };
}

export const birthplaceSchema = object().shape({
  birth_country: string().required(t("This field is required")),
  birth_province_state: string(),
  birth_city: string().required(t("This field is required")),
});
